<div class="container-fluid px-1">
  <form [formGroup]="contactSelectForm" class="w-100">
    <p-autoComplete
      formControlName="ContactSelect"
      [suggestions]="contactSuggestions"
      [multiple]="true"
      [dropdown]="false"
      [forceSelection]="false"
      [minLength]="2"
      field="emailAddress"
      placeholder="Enter or select emails"
      [style]="{ width: '100%' }"
      (completeMethod)="onKeyInput($event)"
      (onSelect)="onSelect($event)"
      (onUnselect)="onUnselect($event)"
      (onKeyUp)="onKeyUp($event)"
      (onBlur)="focusGone($event)">
      <ng-template pTemplate="item" let-item>
        @if (item.firstName) {
          <span>{{item.firstName}}</span>
        }
        @if (item.lastName) {
          <span>&nbsp;{{item.lastName}}</span>
        }
        @if (item.emailAddress) {
          <span> &nbsp;@if (item.firstName || item.lastName) {
            <span>&lt;</span>
            }{{item.emailAddress}}@if (item.firstName || item.lastName) {
            <span>&gt;</span>
          }</span>
        }
      </ng-template>
      <ng-template pTemplate="selectedItem" let-item>
        @if (item.firstName) {
          <span>{{item.firstName}}</span>
        }
        @if (item.lastName) {
          <span>&nbsp;{{item.lastName}}</span>
        }
        @if (item.emailAddress) {
          <span>&nbsp;@if (item.firstName || item.lastName) {
            <span>&lt;</span>
            }{{item.emailAddress}}@if (item.firstName || item.lastName) {
            <span>&gt;</span>
          }</span>
        }
      </ng-template>
    </p-autoComplete>
  </form>
</div>
